import { createReducer, on } from "@ngrx/store";
import { AuthActions } from "./auth.actions.types";
import { UserProfile } from "oidc-client-ts";

export interface AuthState {
  isAuthenticated: boolean;
  accessToken: string;
  expiresAt: number;
  profile: UserProfile;
  autoLogin: boolean;
}

export const defaultState: AuthState = {
  isAuthenticated: false,
  accessToken: "",
  expiresAt: 0,
  profile: {} as UserProfile,
  autoLogin: false
};

export const AuthReducer = createReducer(
  defaultState,
  on(AuthActions.Login, (state, action) => {
    return {
      ...state,
      isAuthenticated: true,
      accessToken: action.accessToken,
      expiresAt: action.expiresAt,
      profile: action.profile,
      autoLogin: action.autoLogin
    };
  }),
  on(AuthActions.Logout, () => {
    return {
      ...defaultState
    };
  }),
  on(AuthActions.TokenRefreshed, (state, { accessToken, expiresAt, profile }) => {
    if (!state.isAuthenticated) {
      return state;
    }

    return {
      ...state,
      accessToken,
      expiresAt,
      profile
    };
  })
);
